import axios from "@/plugins/axios";

export default {
    getAllIncentiveApproaches(params) {
        return axios.httpApi.get("/incentive_approach", { params });
    },
    getIncentiveApproach(incentive_approach_id) {
        return axios.httpApi.get(`/incentive_approach/${incentive_approach_id}`);
    },
    editIncentiveApproach(incentive_approach) {
        const id = incentive_approach.id
        delete incentive_approach.id

        return axios.httpApi.patch(`/incentive_approach/${id}`, incentive_approach);
    },
}